export class LegacyProfileFetchError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "LegacyProfileFetchError"
  }
}
